import { useTranslation } from "react-i18next";
import CommonIcons from "@base/assets/icons";
import { BookingDraft, BookingStep, withOnline } from "@base/modules/appointment/regularBookingRules";

interface IProps {
  draft: BookingDraft;
  onNext: (draft: BookingDraft, step?: BookingStep) => void;
}

/** "Medical services": at a clinic or online with a doctor. */
export default function ChooseTypeStep({ draft, onNext }: IProps) {
  //! state
  const { t } = useTranslation();

  //! render
  const renderOption = (online: boolean, icon: React.ReactNode, title: string, description: string) => (
    <button
      type="button"
      onClick={() => onNext(withOnline(draft, online))}
      className={`flex items-center gap-4 p-4 rounded-2xl border text-left hover:border-common-primary ${
        draft.online === online ? "border-common-primary bg-common-primary50" : "border-common-divider bg-common-white"
      }`}
    >
      <div className="shrink-0">{icon}</div>
      <div className="grow flex flex-col gap-1">
        <span className="text-common-maintext text-base font-semibold font-['Inter']">{title}</span>
        <span className="text-common-subtext text-sm font-normal font-['Inter']">{description}</span>
      </div>
      <CommonIcons.RightOutlined className="text-common-subtext" />
    </button>
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {renderOption(false, <CommonIcons.IconFacilityBox />, t("booking.type.offline"), t("booking.type.offlineDescription"))}
      {renderOption(true, <CommonIcons.IconCameraBox />, t("booking.type.online"), t("booking.type.onlineDescription"))}
    </div>
  );
}
